export default () => ({
  currentStage: 1,
  isLoading: false,
  email: '',
  password: '',
  passwordRepeat: '',
  code: '',
})
